<template>
  <VList
    v-if="demonstrators.length > 0"
    data-testid="demonstratorList"
    class="pa-0 overflow-y-auto demo-list"
    style="max-height: 302px;"
  >
    <template v-for="demonstrator in demonstrators" :key="demonstrator.demoId">
      <VDivider
        class="px-4 my-0"
      />
      <VListItem
        class="py-2 px-4"
        style="margin-left: -2px;"
        data-testid="demonstrator-item"
        v-bind="resultFocusTarget"
        @click="selectDemonstrator(demonstrator)"
      >
        <template #prepend>
          <VIcon
            color="hover"
            size="24"
            class="mr-2"
            data-testid="demo-select"
            data-seo-id="demonstrator"
          >
            {{ icons.mdiRadioboxBlank }}
          </VIcon>
          <DemonstratorAvatar :demonstrator="demonstrator" :size="40" />
        </template>

        <div class="text-left pl-3">
          <VListItemTitle data-testid="demonstrator-name" class="font14">
            {{ getName(demonstrator) }}
          </VListItemTitle>
          <VListItemSubtitle
            class="font14 text-greyedOut text--wrap"
            data-testid="location"
          >
            {{ getLocation(demonstrator) }}
          </VListItemSubtitle>
        </div>
      </VListItem>
    </template>
  </VList>
</template>


<script lang="ts" setup>
import { mdiRadioboxBlank } from '@mdi/js'
import DemonstratorAvatar from '~/components/account/demonstrator/DemonstratorAvatar.vue'
import type { Demonstrator } from '~/types/account'
import { DEMONSTRATOR_RESULT_ATTR } from '~/utils/focus'

const icons = { mdiRadioboxBlank }
// The finders land on the first result once a search renders. AB#65420
const resultFocusTarget = { [DEMONSTRATOR_RESULT_ATTR]: '' }
withDefaults(defineProps<{ demonstrators?: Demonstrator[] }>(), {
  demonstrators: () => []
})
const emits = defineEmits<{
  (e: 'demo-selected', demonstrator: Demonstrator): void
}>()

const getName = (demonstrator: Demonstrator) => `${demonstrator.firstName} ${demonstrator.lastName}`
const getLocation = (demonstrator: Demonstrator) => {
  return [demonstrator.city, demonstrator.suburb, demonstrator.region, demonstrator.county].filter(Boolean).join(', ')
}
const selectDemonstrator = (demonstrator: Demonstrator) => {
  emits('demo-selected', demonstrator)
}
</script>

<style lang="scss" scoped>
.background-grey {
  background-color: rgb(var(--v-theme-backgroundDiv));
  border-color: rgb(var(--v-theme-border));
}
.mobile-max-width {
  max-width:320px;
}
// Match V2 compact divider spacing between list items
.demo-list :deep(.v-divider) {
  margin: 0;
}
</style>
